import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

export interface AuthState {
  loggedInUser: Person;
  isAuthorized: boolean;
  companies?: WintSuperkollAPIModel.Company[];
  selectedCompanyId?: number;
  selectedCompany: WintSuperkollAPIModel.Company;
  fetchingRefreshToken: boolean;
  profileToggles: WintSuperkollAPIModel.ProfileToggles;
  canPayEmployee?: boolean;
  /** The person's Heart setting for the "Samtliga bolag" overview; undefined until the profile has loaded. */
  showAllCompaniesTodoOverview?: boolean;
  businessUnitManagerSettings: BusinessUnitManagerSettings;
  taxAgent?: WintSuperkollAPIModel.IncomingInvoiceSupplierInfo;
}

export class Person {
  key: string;
  mail: string;
  name: string;
  paymentMethods: WintSuperkollAPIModel.ReceiptPaymentMethod[];
  wintCardPaymentMethods: WintSuperkollAPIModel.ReceiptPaymentMethod[];
  personId: number;
  personNumber: string;
  receiptBankAccount: string;
  receiptBankClearing: string;
  profileImage?: WintSuperkollAPIModel.ProfileImage;
  isHeartUser: boolean;
  authTokens: WintSuperkollAPIModel.AuthTokens;
  hasMissingPaymentDetails: boolean;
  unsignedEula: boolean;
  canSuspendEula: boolean;

  constructor() {
    this.key = "";
    this.mail = "";
    this.name = "";
    this.paymentMethods = [];
    this.personId = 0;
    this.wintCardPaymentMethods = [];
    this.personNumber = "";
    this.receiptBankAccount = "";
    this.receiptBankClearing = "";
    this.isHeartUser = false;
    this.authTokens = { accessToken: "", refreshToken: "" };
    this.hasMissingPaymentDetails = false;
    this.unsignedEula = false;
    this.canSuspendEula = true;
  }
}

export interface OnboardingSession {
  token: string;
  expiresAt: string;
  /**
   * The invite this session was minted for. A visitor can open a second invite while the
   * first session is still live, and the token itself is opaque -- only the server knows
   * which company it belongs to -- so without this the wizard would silently run the new
   * invite's route against the previous invite's onboarding.
   */
  inviteToken: string;
  /** For the identity chip. Absent on sessions minted before this was stored. */
  givenName?: string;
  surname?: string;
}

export class BusinessUnitManagerSettings {
  manageableEmployeesLoaded: boolean;
  manageableEmployees: number[];

  constructor() {
    this.manageableEmployeesLoaded = false;
    this.manageableEmployees = [];
  }
}
